/** Official site URLs keyed by data.js `name` */
const toolUrls = {
  D3: 'https://d3js.org/',
  Raphaël: 'https://dmitrybaranovskiy.github.io/raphael/',
  ECharts: 'https://echarts.apache.org/',
  Recharts: 'https://recharts.org/',
  Lodash: 'https://lodash.com/',
  'Moment JS': 'https://momentjs.com/',
  Redux: 'https://redux.js.org/',
  'Bootstrap CSS': 'https://getbootstrap.com/',
  ExpressJS: 'https://expressjs.com/',
  KoaJS: 'https://koajs.com/',
  ReactJS: 'https://react.dev/',
  Vue: 'https://vuejs.org/',
  'Element UI': 'https://element-plus.org/',
  'Google Chrome & Devtool': 'https://developer.chrome.com/docs/devtools/',
  'Jenkins CI': 'https://www.jenkins.io/',
  'Sublime Text 3': 'https://www.sublimetext.com/',
  'Visual Studio Code': 'https://code.visualstudio.com/',
  'Performance Tooling': 'https://pagespeed.web.dev/',
  PostCSS: 'https://postcss.org/',
  MongoDB: 'https://www.mongodb.com/',
  NodeJS: 'https://nodejs.org/',
  'Docker Platform': 'https://www.docker.com/',
  AWS: 'https://aws.amazon.com/',
  'HTML5 & CSS3': 'https://developer.mozilla.org/',
  JavaScript: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript',
  ECMASCRIPT: 'https://tc39.es/',
  'CSS Next': 'https://postcss.org/',
  GraphQL: 'https://graphql.org/',
  'SASS (SCSS flavor)': 'https://sass-lang.com/',
  TypeScript: 'https://www.typescriptlang.org/',
  BabelJS: 'https://babeljs.io/',
  'Front End Code Guide': 'https://codeguide.co/',
  ESLint: 'https://eslint.org/',
  'Gitflow Workflow': 'https://www.atlassian.com/git/tutorials/comparing-workflows/gitflow-workflow',
  Webpack: 'https://webpack.js.org/',
  jQuery: 'https://jquery.com/',
  'Ant Design': 'https://ant.design/',
  'Material Design': 'https://m3.material.io/',
  'shadcn/ui': 'https://ui.shadcn.com/',
  'Tailwind CSS': 'https://tailwindcss.com/',
  GSAP: 'https://gsap.com/',
  PHP: 'https://www.php.net/',
  'Vercel AI SDK': 'https://sdk.vercel.ai/',
  'LangChain.js': 'https://js.langchain.com/',
  'Transformers.js': 'https://huggingface.co/docs/transformers.js/',
  CopilotKit: 'https://www.copilotkit.ai/',
  'assistant-ui': 'https://www.assistant-ui.com/',
  'LlamaIndex.TS': 'https://ts.llamaindex.ai/',
  'OpenAI API': 'https://platform.openai.com/',
  'TensorFlow.js': 'https://www.tensorflow.org/js',
  'ONNX Runtime Web': 'https://onnxruntime.ai/docs/get-started/with-javascript/web.html',
  Cursor: 'https://cursor.com/',
  'GitHub Copilot': 'https://github.com/features/copilot',
  v0: 'https://v0.dev/',
  MCP: 'https://modelcontextprotocol.io/',
  'Bolt.new': 'https://bolt.new/',
  Windsurf: 'https://windsurf.com/',
};

export default toolUrls;
